import { render, staticRenderFns } from "./viewDetail.vue?vue&type=template&id=1e212ada&scoped=true&lang=pug"
import script from "./viewDetail.vue?vue&type=script&lang=js"
export * from "./viewDetail.vue?vue&type=script&lang=js"
import style0 from "./viewDetail.vue?vue&type=style&index=0&id=1e212ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e212ada",
  null
  
)

export default component.exports